import { callApi } from 'services/config';
import { ErrorContext, logError } from 'utils/error';

// Define a custom error type
class FetchError extends Error {
  status: number;
  body: any;

  constructor(message: string, status: number, body: any = null) {
    super(message);
    this.name = 'SWRFetcherError';
    this.status = status;
    this.body = body;
  }
}

/**
 * `errorContext` lets callers classify failures at capture time (e.g. tag an
 * expected 4xx with `thera_error_type` so error-tracking monitors can exclude
 * it). The function form receives the raw `callApi` error (carries
 * `httpStatus`); return undefined to log without extra context.
 */
export function fetcher(
  url: string,
  method = 'GET',
  data = {},
  errorContext?: ErrorContext | ((error: unknown) => ErrorContext | undefined),
) {
  return () =>
    callApi(url, method, data)
      .then((res) => res)
      .catch((error) => {
        if (error.code === 'INTERNET_DISCONNECTED' || error?.message?.includes('Network Error')) {
          return;
        }
        logError(error, typeof errorContext === 'function' ? errorContext(error) : errorContext);
        const errorName = error.httpStatus === 404 ? '404 Error' : 'An error occurred while fetching the data';
        throw new FetchError(errorName, error.httpStatus, error?.message);
      });
}
